var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoltar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_7095)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4764 22.7032L10.2047 16.0541C10.1303 15.9749 10.0774 15.8892 10.0462 15.7968C10.0149 15.7045 9.99952 15.6055 10 15.5C10 15.3945 10.0154 15.2955 10.0462 15.2032C10.0769 15.1108 10.1298 15.0251 10.2047 14.9459L16.4764 8.27704C16.6501 8.09235 16.8672 8 17.1278 8C17.3883 8 17.6117 8.09894 17.7978 8.29683C17.9839 8.49472 18.0769 8.72559 18.0769 8.98945C18.0769 9.2533 17.9839 9.48417 17.7978 9.68206L12.3263 15.5L17.7978 21.3179C17.9715 21.5026 18.0583 21.7303 18.0583 22.0011C18.0583 22.2718 17.9653 22.5058 17.7792 22.7032C17.5931 22.9011 17.3759 23 17.1278 23C16.8797 23 16.6625 22.9011 16.4764 22.7032Z",
    fill: "#5AB2AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_7095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltar);
export default __webpack_public_path__ + "static/media/Voltar.35c125eb9f688eb427a4e7a17571d22b.svg";
export { ForwardRef as ReactComponent };